import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { UserNotificationResponseItemByProject } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  userId: number
  options?: Omit<
    UseQueryOptions<UserNotificationResponseItemByProject[], Error>,
    'queryKey' | 'queryFn'
  >;
}

export const useUserProjectNotificationsRequest = ({
  userId,
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useQuery<UserNotificationResponseItemByProject[], Error>(
    [Entities.UserNotifications, 'by-project', userId],
    async () => {
      const { data } = await api.v1AdminUsersUserIdNotificationsByProjectGet(userId)
      return data as unknown as UserNotificationResponseItemByProject[]
    },
    options,
  )
}
